<script>
export default {
  name: "DataDialog",
  props: {
    warnconfig: {
      title: String,
      visible: Boolean,
      operate: String,
      formData: {},
    }
  },
  data() {
    const piCheck = (rule, value, callback) => {
      let reg =  /^[1-9]\d*$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正整数"));
      }
      callback();
    };
    return {
      yjlevelList: [],
      isFullScreen: false,
      rules: {
        stcd: [
          { required: true, message: '请选择预警对象', trigger: 'blur' },
        ],
        yjlbbh: [
          { required: true, message: '请选择预警类别', trigger: 'blur' },
        ],
        yz: [
          { required: true, message: '请输入预警值', trigger: 'blur' },
        ],
        yjcxsj: [
          { required: true, message: '请输入持续时间', trigger: 'blur' },
        ],
        yjlevel: [
          { required: true, message: '请选择预警等级', trigger: 'blur' },
        ],
        nr: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        no: [
          { required: true, message: '请输入序号', trigger: 'blur' },
          { required: true, trigger: "blur", validator: piCheck }
        ],
        autoSend: [
          { required: true, message: '请选择是否自动发布', trigger: 'blur' },
        ],
      },
      stcdList: [],
      yjlbbhList: [],
      autoSendList: [{
        value: true,
        label: '是'
      }, {
        value: false,
        label: '否'
      }]
    }
  },
  methods: {
    handleClose() {
      this.warnconfig.formData = {};
      this.$refs["df"].clearValidate();
    },
    add() {
      this.request.post("/rm-tyjgz/addYjgz", this.warnconfig.formData).then(
          (res) => {
            if (res.ok) {
              this.$message.success("新增成功！");
              this.$emit('query');
              this.warnconfig.visible = false;
            } else {
              this.$message.error(res.error.message);
            }
          });
    },
    edit() {
      this.request.post("/rm-tyjgz/modifyYjgz", this.warnconfig.formData).then(
          (res) => {
            if (res.ok) {
              this.$message.success("修改成功！");
              this.$emit('query');
              this.warnconfig.visible = false;
            } else {
              this.$message.error(res.error.message);
            }
          });
    },
    save() {
      this.$refs['df'].validate((valid) => {
        if (valid) {
          this.$confirm("确定要保存吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(
              () => {
                if (this.warnconfig.operate === 'add') {
                  this.add();
                } else {
                  this.edit();
                }
              }
          );
        } else {
          return false;
        }
      });
    },
    init() {
      this.request.get('/rm-sdictionary/v1/query/07').then(
          (res) => {
            if (res.ok) {
              this.yjlbbhList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
      this.request.get('/rm-sdictionary/v1/query/11').then(
          (res) => {
            if (res.ok) {
              this.yjlevelList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    changeYJLBBH(val) {
      this.request.get(`/rm-bstmp/queryByYjlbbh/${val}`).then(
          (res) => {
            if (res.ok) {
              this.stcdList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    numberInput(val, int, dec) {
      let INTEGER_LENGTH = int;
      let DECIMAL_LENGTH = dec;
      let str = val.replace('-', '');
      let intStr, decStr;

      // 判断是否是浮点数
      if (str.indexOf('.') === -1) {
        intStr = str;
      } else {
        let arr = str.split('.');
        intStr = arr[0];
        decStr = arr[1];
      }

      // 处理整数位
      if (intStr.length > INTEGER_LENGTH) {
        intStr = intStr.substr(0, INTEGER_LENGTH);
      }

      // 处理小数位
      if (decStr && decStr.length > DECIMAL_LENGTH) {
        decStr = decStr.substr(0, DECIMAL_LENGTH);
      }

      // 组合
      if (val.indexOf('-') === -1) {
        return decStr ? intStr + '.' + decStr : intStr;
      } else {
        return decStr ? '-' + intStr + '.' + decStr : '-' + intStr;
      }
    }
  },
  mounted() {
    this.init();
  },
}
</script>

<template>
  <el-dialog
      v-dialogDrag
      :closeOnClickModal="false"
      :visible.sync="warnconfig.visible"
      class="abow_dialog"
      top="5vh"
      width="45vw"
      :fullscreen="isFullScreen"
      append-to-body
      @close="handleClose">
    <div slot="title" class="header-title">
      <div class="dgTitle">{{ warnconfig.title }}</div>
      <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="warnconfig.visible = false"></el-image>
    </div>
    <el-form ref="df" :model="warnconfig.formData" :rules="rules">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="预警类别" prop="yjlbbh">
            <el-select
                v-model="warnconfig.formData.yjlbbh"
                :disabled="warnconfig.operate === 'edit'"
                style="width: 100%"
                placeholder="请选择预警类别"
                @change="changeYJLBBH">
              <el-option
                  v-for="item in yjlbbhList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预警对象" prop="stcd">
            <el-select v-model="warnconfig.formData.stcd" style="width: 100%" placeholder="请选择预警对象" v-if="warnconfig.operate === 'add'">
              <el-option
                  v-for="item in stcdList"
                  :key="item.k"
                  :label="item.v"
                  :value="item.k">
              </el-option>
            </el-select>
            <el-input v-else disabled v-model="warnconfig.formData.stnm"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预警值" prop="yz">
            <el-input v-model="warnconfig.formData.yz" type="number"
                      @input="warnconfig.formData.yz = numberInput(warnconfig.formData.yz, 8, 2)">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="持续时间" prop="yjcxsj">
            <el-input
                v-model="warnconfig.formData.yjcxsj"
                type="number"
                @input="warnconfig.formData.yjcxsj = numberInput(warnconfig.formData.yjcxsj, 19, 1)">
              <template #suffix>
                <span>（小时）</span>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预警等级" prop="yjlevel">
            <el-select v-model="warnconfig.formData.yjlevel" style="width: 100%" placeholder="请选择预警等级">
              <el-option
                  v-for="item in yjlevelList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否自动发布" prop="autoSend">
            <el-select v-model="warnconfig.formData.autoSend" style="width: 100%" placeholder="请选择是否自动发布">
              <el-option
                  v-for="item in autoSendList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="序号" prop="no">
            <el-input v-model="warnconfig.formData.no" :maxlength="3"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="nr">
            <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                :maxlength="200"
                v-model="warnconfig.formData.nr">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="warnconfig.visible = false" class="dgClose">关 闭</el-button>
        <template>
          <el-button
              slot="reference"
              type="primary"
              @click="save"
              class="dgSave">保 存
          </el-button>
        </template>
    </span>
  </el-dialog>
</template>

<style scoped>
::v-deep .el-dialog {
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  height: 6vh;
  line-height: 6vh;
  padding: 0;
  background-color: #f9f9ff;
  position: relative;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 5vh;
  line-height: 5vh;
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  position: absolute;
  left: 0;
  top: 5vh;
  bottom: 70px;
  right: 0;
  overflow: auto;
}

::v-deep .dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 70px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: Center;
  box-sizing: border-box;
  padding-right: 20px;
}

::v-deep .el-dialog {
  height: 70%;
}

.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave{
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>